// extracted by mini-css-extract-plugin
export var entries = "BetsList-module--entries--780ef";
export var entryButtons = "BetsList-module--entryButtons--bdf5b";
export var entryMessage = "BetsList-module--entryMessage--770de";